export const USER_TYPES = {
  customer: 'customer',
  tenant: 'tenant',
  developer: 'developer',
} as const;

export type StandaloneUserType = (typeof USER_TYPES)[keyof typeof USER_TYPES];

export type EnvFlagBooleanString = 'true' | 'false';

export type StandaloneShellEnvFlagDefaults = Partial<Record<string, EnvFlagBooleanString>>;

export const STANDALONE_ENV_FLAGS_CONST = {
  storage: {
    shellOverridePrefix: 'StandaloneEnvFlagOverrides',
  },
} as const;

export const USER_TYPE_SWITCH_CONST = {
  defaults: {
    tenantOrgName: 'test-tenant-3',
    customerOrgName: 'hbo',
    developerOrgName: 'hbo-gdp',
    userType: USER_TYPES.customer,
    apiSdkMocksEnabled: 'true',
  },
  cookies: {
    tenantOrgName: 'tenantOrgName',
    customerOrgName: 'customerOrgName',
    developerOrgName: 'developerOrgName',
    userTypeSwitch: 'userTypeSwitch',
    apiSdkMocksEnabled: 'apiSdkMocksEnabled',
  },
  storage: {
    apiSdkMocksEnabled: 'ApiSdkMocksEnabled',
  },
  events: {
    userTypeToggle: 'user-type-toggle',
  },
} as const;
